import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource, Sort, PageEvent, MatExpansionPanel, MatDialog, MatSort, MatSnackBar } from '@angular/material';
import { UsuarioService } from '../../../providers/usuario.service';
import { CertificacionesService } from '../../../providers/certificaciones.service';
import { Curso } from '../../../interfaces/curso';
import { Clasificacion } from '../../../interfaces/clasificacion';
// import { OrdenEstadoPropuestaDialog } from '../ordenar-estados-propuesta/ordenar-estado-propuesta-dialog.component';

@Component({
  selector: 'app-ver-certificaciones',
  templateUrl: './ver-certificaciones.component.html',
  styleUrls: ['./ver-certificaciones.component.scss']
})
export class VerCertificacionesComponent implements OnInit {
  readonly titulo = 'clasificacion';
  cursosColumnas = ['id', 'descripcion', 'estado' ,'acciones'];
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  filtros: any = {
    generico: '',
    descripcion: ''
  };
  title = "Clasificacion";
  descargandolistado: boolean = false;
  cargando: boolean;
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  clasificacionDataSource = new MatTableDataSource();

  tieneFiltrosOrdenPaginado = false;
  panelConFiltroActivo = false;
  total: number;
  @Input() acciones: boolean = false; // true para mostrar las acciones de ABM etc...
  @Input() conFiltro: boolean = false; // mostrar u ocultar el input de filtros.
  @Input() conSort: boolean = false; // mostrar u ocultar el sort en la columna.
  @Output() onChange = new EventEmitter();
  @ViewChild(MatSort) matSort: MatSort;
  @ViewChild('filtrosPanel') set filtrosPanel(v: MatExpansionPanel) {
    if (typeof v != 'undefined') {
      setTimeout(() => {
        this.checkPageState();
        if (this.panelConFiltroActivo) {
          v.open();
        }
      }, 25);
    }
  };

  constructor(
    private usuariosSv: UsuarioService,
    private certificacionesSv: CertificacionesService,
    private snackBar: MatSnackBar,
  ) { }
  @Input('filtrado') filtrado: boolean = true;

  ngOnInit() {
    console.log('Inicia Bien!!!!!!!!!!!!!!!');
    this.actualizarTabla();
  }

  _limpiarPageState() {
    // filtros
    localStorage.setItem('ver_cursos_filtros', null);
    // paginado
    localStorage.setItem('ver_cursos_paginado', null);
    // sort
    localStorage.setItem('ver_cursos_sort', null);
  }

  recordarPageState() {
    // filtros
    localStorage.setItem('ver_cursos_filtros', JSON.stringify(this.filtros));
    // paginado
    localStorage.setItem('ver_cursos_paginado', JSON.stringify(this.page));
    // sort
    localStorage.setItem('ver_cursos_sort', JSON.stringify(this.sort));
  }

  checkPageState(): boolean {
    this.tieneFiltrosOrdenPaginado = false;
    // checkear si hay almenos un filtro aplicado
    this.panelConFiltroActivo = false;
    for (let propiedad in this.filtros) {
      if (this.filtros[propiedad]) {
        this.tieneFiltrosOrdenPaginado = true;
        this.panelConFiltroActivo = true;
        break;
      }
    }
    // checkear si hay paginado
    if (this.page.pageIndex != 0) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    // checkear si hay ordenamiento
    if (this.sort.active != '' && (this.sort.active != 'fechaModificacion' || this.sort.direction != 'desc')) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    return this.tieneFiltrosOrdenPaginado;
  }

  restaurarPageState() {
    // filtros
    let localFiltros = JSON.parse(localStorage.getItem('ver_contactos_filtros'));
    if (localFiltros != null) {
      this.filtros = localFiltros;
    } else {
      for (let propiedad in this.filtros) {
        this.filtros[propiedad] = '';
      }
    }
    // paginado
    let localPaginado = JSON.parse(localStorage.getItem('ver_contactos_filtros'));
    if (localPaginado != null) {
      this.page = localPaginado;
    } else {
      this.page.pageIndex = 0;
      this.page.pageSize = +localStorage.getItem('ver_contactos_paginado_size') || 10;
      this.page.length = 0;
    }
    // sort
    let localSort = JSON.parse(localStorage.getItem('ver_contactos_sort'));
    if (localSort != null) {
      // para el sort tenemos que hacerlo con un "set" porque arregla un bug de "matSort"
      this.setActiveSortProgrammatically(localSort.active, localSort.direction);
    } else {
      this.setActiveSortProgrammatically('IdContacto', 'desc');
    }
    this.actualizarTabla();
  }

  /**
 * Para arreglar un bug de angular usamos esta funcion para ordenar
 */
  setActiveSortProgrammatically(active, direction): void {
    let interval = setInterval(() => {
      if (this.matSort) {
        clearInterval(interval);
        if (this.sort.active != active || this.sort.direction != direction) {
          this.sort = <MatSort>{
            active: active,
            direction: direction
          };
          this.matSort.sort({
            id: active,
            start: direction,
            disableClear: true
          });
          // ugly hack!
          const activeSortHeader = this.matSort.sortables.get(active);
          if (activeSortHeader) {
            activeSortHeader['_setAnimationTransitionState']({
              fromState: direction,
              toState: 'active'
            });
          }
        }
      }
    }, 0);
  }

  sortData(sort: Sort) {
    this.sort = sort;
    this.actualizarTabla();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem('ver_' + this.titulo + '_paginado_size', pageEvent.pageSize.toString());
    this.page = pageEvent;
    this.actualizarTabla();
  }

  // get todas las propieades de un objeto (y sus sub objetos) en un objeto plano
  flattenObject = function (ob) {
    var toReturn = {};

    for (var i in ob) {
      if (!ob.hasOwnProperty(i)) continue;

      if ((typeof ob[i]) == 'object') {
        var flatObject = this.flattenObject(ob[i]);
        for (var x in flatObject) {
          if (!flatObject.hasOwnProperty(x)) continue;
          toReturn[i + '.' + x] = flatObject[x];
        }
      } else {
        toReturn[i] = ob[i];
      }
    }

    return toReturn;
  };

  onFiltro() {
    this.page.pageIndex = 0;
  }
  reiniciarPageState() {
    this._limpiarPageState();
    this.restaurarPageState();
    this.actualizarTabla();
  }


  setCargando(cargando: boolean = true): void { // cambiar el estado de la barra de cargando
    this.cargando = cargando;
  }

  actualizarTabla(): void {

    this.certificacionesSv.getClasificacion().subscribe(
      respuesta => {
        console.log("grupos", respuesta);
        let clasificacion = [];
        respuesta.certificacion.forEach(element => {
          clasificacion.push({
            id: element.id,
            descripcion: element.descripcion,
            estado_tipo_contacto: element.estado_certificacion
          })
        });
        this.clasificacionDataSource.data = clasificacion;
      },

      (err) => {

      }
    );

  }

  cambiarEstado(event, element){
    console.log(event, "evento");
    // let clasificacion_cambiar: Clasificacion;

    // clasificacion_cambiar = new Clasificacion(element.id, element.descripcion, event.target.value);

    this.certificacionesSv.editarClasificacion(element.id, event.target.value,element.descripcion).subscribe(
      respuesta => {
        if(respuesta.estado == 1){
          this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
          this.actualizarTabla();
        }else{
          this.snackBar.open(respuesta.mensaje, '', { duration: 2750 });
          return;
        }
      }, () => {

      }
    )
    
  }

  fallaDescargarListado() {
    this.snackBar.open('Lo sentimos, no se pudo descargar el listado', 'OK', { duration: 4750 });
  }
}